var map = {
	"./american-pekin-duck.jpg": "e016",
	"./beaver.jpg": "be63",
	"./camel.jpg": "16b6",
	"./card-background.jpg": "83da",
	"./cheetah.jpg": "76f4",
	"./deer.jpg": "f781",
	"./dog.jpg": "7f1a",
	"./duck.jpg": "5cab",
	"./elephant.jpg": "5271",
	"./giraffe.jpg": "e5a8",
	"./great-white-pelican.jpg": "87bd",
	"./green-sea-turtle.jpg": "1728",
	"./hen.jpg": "baa7",
	"./horse.jpg": "24f0",
	"./kangaroo.jpg": "c435",
	"./ladybug.jpg": "1db1",
	"./land-turtle.jpg": "49a9",
	"./lion.jpg": "295f",
	"./mantis.jpg": "ad36",
	"./owl.jpg": "acd5",
	"./panda.jpg": "dc9f",
	"./parrot.jpg": "b90d",
	"./pig.jpg": "acac",
	"./rabbit.jpg": "48b5",
	"./ram.jpg": "a8fa",
	"./rhino.jpg": "3c7b",
	"./sheep.jpg": "c242",
	"./snail.jpg": "c094",
	"./toucan.jpg": "0497",
	"./white-sea-turtle.jpg": "4812"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";